import { Text } from '@hangar/web-components/core/Text';
import { useTranslation } from '../../hooks/i18n';
import { flightChangesEmptyStateUrl } from './flightChangesCasesPublicAssets';
import * as S from './FlightChangesCases.styles';

export type FlightChangesTableEmptyVariant = 'filtered' | 'global';

interface FlightChangesCasesTableEmptyProps {
    variant: FlightChangesTableEmptyVariant;
}

export const FlightChangesCasesTableEmpty = ({ variant }: FlightChangesCasesTableEmptyProps) => {
    const { t } = useTranslation();
    const testId =
        variant === 'filtered' ? 'flight-cases-filtered-empty' : 'flight-cases-global-empty';
    const descriptionKey =
        variant === 'filtered'
            ? 'flightChangesCases.emptyMessage.description'
            : 'flightChangesCases.emptyMessage.descriptionGlobal';

    return (
        <S.EmptyStateInTable data-testid={testId}>
            <S.EmptyStateIllustration
                src={flightChangesEmptyStateUrl}
                alt=""
                width={136}
                height={136}
                decoding="async"
            />
            <Text variant="heading-sm" bold={true}>
                {t('flightChangesCases.emptyMessage.title')}
            </Text>
            <Text variant="body-md" color="secondary">
                {t(descriptionKey)}
            </Text>
        </S.EmptyStateInTable>
    );
};
